export default __webpack_public_path__ + "assets/8845c2807e37fd142a1bc51f80e949dc.png";